/* ============================================================
   CYPHER REVIEWS v4 — Complete JS (Updated Viewer & Fixed z-index)
   ============================================================ */
(function () {
  'use strict';

  var API_URL = 'https://script.google.com/macros/s/AKfycbyYe9ArHKw_ZCWnL3grVvubyhYby1-NamNiVMoSt8pI4tSbi_wkfmlpzz9F0A85VW4f/exec';
  var CLOUD_NAME = 'dxl92sox7';
  var UPLOAD_PRESET = 'cypher_reviews';

  var COLLECTIONS = [
    {
      name: "Paddock '74 Chronograph",
      handles: ['paddock-74-ignition-orange', 'cypher-paddock-74-ignition-orange-orange-strap', 'paddock-74-le-mans-blue', 'cypher-paddock-74-le-mans-blue-black-strap','paddock-74-silverstone-green','cypher-paddock-74-silverstone-green-black-strap','paddock-74-grand-prix-panda','cypher-paddock-74-grand-prix-panda-orange-strap', 'cypher-paddock-74-monza-red-black-strap']
    },
    {
      name: "Cypher Legacy",
      handles: ['cypher-legacy-bordeaux', 'cypher-legacy-glacier', 'cypher-legacy-midnight', 'cypher-legacy-evergreen', 'cypher-legacy-obsidian', 'cypher-legacy-cognac']
    },
    {
      name: "Cypher Aphelion",
      handles: ['cypher-aphelion']
    }
  ];

  function getGroupHandles(handle) {
    for (var i = 0; i < COLLECTIONS.length; i++) {
      if (COLLECTIONS[i].handles.indexOf(handle) !== -1) return COLLECTIONS[i].handles;
    }
    return [handle];
  }

  var LABELS = ['', 'Poor', 'Fair', 'Good', 'Very Good', 'Excellent'];
  var PER_PAGE = 10, MAX_FILES = 3, MAX_IMG = 10485760, MAX_VID = 52428800;

  function $(s,c){return(c||document).querySelector(s)}
  function $$(s,c){return Array.from((c||document).querySelectorAll(s))}
  function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML}
  function fmtDate(d){return new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'})}
  function gel(id){return document.getElementById(id)}

  function starsHtml(r,sz){
    var c=sz||'sm',f=Math.round(r),h='<span class="cr-stars cr-stars--'+c+'">';
    for(var i=0;i<f;i++)h+='<svg class="cr-star-full" viewBox="0 0 24 24"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/></svg>';
    for(var j=f;j<5;j++)h+='<svg class="cr-star-empty" viewBox="0 0 24 24"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="1" fill="none"/></svg>';
    return h+'</span>';
  }

  function galleryHtml(media,rid){
    if(!media||!media.length)return '';
    var mx=4,items=media.slice(0,mx),ex=media.length-mx,h='<div class="cr-gallery">';
    items.forEach(function(m,i){
      var iv=m.type==='video',th=iv?(m.thumb||m.url.replace(/\.[^.]+$/,'.jpg')):m.url.replace('/upload/','/upload/c_fill,w_200,h_200,q_auto/');
      h+='<div class="cr-gallery__item" data-review-id="'+esc(rid)+'" data-media-idx="'+i+'"><img src="'+esc(th)+'" alt="Review media" loading="lazy">';
      if(iv)h+='<div class="cr-gallery__play"><svg width="24" height="24" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z"/></svg></div>';
      h+='</div>';
    });
    if(ex>0)h+='<div class="cr-gallery__more" data-review-id="'+esc(rid)+'" data-media-idx="'+mx+'">+'+ex+'</div>';
    return h+'</div>';
  }

  function truncate(s,max){if(!s||s.length<=max)return esc(s||'');return esc(s.substring(0,max))+'<span class="cr-ellipsis">...</span>'}

  function cardHtml(r,sm){
    var pinHtml=r.pinned?'<span class="cr-card__pin"><svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z"/></svg>Pinned</span>':'';
    var verifiedHtml='<span class="cr-card__verified"><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg></span>';
    var titleHtml=r.title?'<h3 class="cr-card__title">'+truncate(r.title,60)+'</h3>':'';
    var bodyHtml='<p class="cr-card__body">'+truncate(r.body,200)+'</p>';
    var modelHtml=sm&&r.product_title?'<span class="cr-card__model">'+esc(r.product_title)+'</span>':'';
    return '<article class="cr-card'+(r.pinned?' cr-card--pinned':'')+'" data-review-id="'+r.id+'">'+pinHtml+'<div class="cr-card__header"><div class="cr-card__author"><div class="cr-card__avatar">'+esc(r.name.charAt(0).toUpperCase())+'</div><div><div class="cr-card__name-row"><span class="cr-card__name">'+esc(r.name)+'</span>'+verifiedHtml+'</div></div></div></div><div class="cr-card__rating">'+starsHtml(r.rating,'sm')+'</div>'+titleHtml+galleryHtml(r.media,r.id)+bodyHtml+modelHtml+'<div class="cr-card__footer"><button class="cr-helpful" data-id="'+r.id+'"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>Helpful'+(r.helpful>0?' ('+r.helpful+')':'')+'</button></div></article>';
  }

  // ============================================================
  // RICH MEDIA VIEWER — v2 Shareable Card Layout
  // ============================================================
  var reviewsStore = {};
  function storeReviews(reviews){reviews.forEach(function(r){reviewsStore[r.id]=r})}

  var viewer = null;
  function getViewer() {
    if (viewer) return viewer;
    var el = document.createElement('div');
    el.className = 'cr-viewer';
    el.hidden = true;

    /* MODIFIED: Safely increased the viewer's z-index to max absolute value to float above the header */
    var viewerStyle = document.createElement('style');
    viewerStyle.textContent = '.cr-viewer{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:2147483647;background:rgba(0,0,0,.92);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);display:flex;align-items:center;justify-content:center;opacity:1;transition:opacity .3s}.cr-viewer[hidden]{display:none}.cr-viewer__topbar{position:absolute;top:0;left:0;right:0;display:flex;align-items:center;justify-content:space-between;padding:16px 20px;z-index:10}.cr-viewer__counter{font-family:"Montserrat",sans-serif;font-size:11px;font-weight:500;color:rgba(255,255,255,.4);letter-spacing:1px}.cr-viewer__close{width:40px;height:40px;border-radius:50%;border:1px solid rgba(255,255,255,.15);background:rgba(0,0,0,.4);display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all .2s;color:#fff}.cr-viewer__close:hover{border-color:rgba(255,255,255,.4);background:rgba(255,255,255,.1)}.cr-viewer__card{width:92vw;max-width:900px;max-height:88vh;background:#0A0A0A;border-radius:14px;border:1px solid rgba(255,255,255,.08);overflow:hidden;display:flex;flex-direction:row;box-shadow:0 30px 80px rgba(0,0,0,.6)}.cr-viewer__media-side{flex:0 0 50%;background:#000;position:relative;display:flex;align-items:center;justify-content:center;min-height:400px;overflow:hidden}.cr-viewer__media{width:100%;height:100%;object-fit:contain;display:block}.cr-viewer__nav{position:absolute;top:50%;transform:translateY(-50%);width:36px;height:36px;border-radius:50%;border:1px solid rgba(255,255,255,.15);background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;cursor:pointer;color:#fff;transition:all .2s;z-index:5}.cr-viewer__nav:hover{background:rgba(255,255,255,.15);border-color:rgba(255,255,255,.3)}.cr-viewer__prev{left:12px}.cr-viewer__next{right:12px}.cr-viewer__dots{position:absolute;bottom:12px;left:50%;transform:translateX(-50%);display:flex;gap:6px;z-index:5}.cr-viewer__dot{width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,.25);border:none;cursor:pointer;padding:0;transition:all .2s}.cr-viewer__dot.active{background:#D95F00;width:18px;border-radius:3px}.cr-viewer__no-media{display:flex;align-items:center;justify-content:center;width:100%;height:100%;min-height:300px;background:#111}.cr-viewer__review-side{flex:1;display:flex;flex-direction:column;overflow-y:auto;padding:0}.cr-viewer__review-side::-webkit-scrollbar{width:4px}.cr-viewer__review-side::-webkit-scrollbar-track{background:transparent}.cr-viewer__review-side::-webkit-scrollbar-thumb{background:rgba(255,255,255,.1);border-radius:4px}.cr-viewer__brand{padding:20px 24px 0;display:flex;align-items:center;justify-content:space-between}.cr-viewer__brand-logo{font-family:"Montserrat",sans-serif;font-size:11px;font-weight:700;letter-spacing:4px;color:rgba(255,255,255,.2);text-transform:uppercase}.cr-viewer__brand-badge{font-family:"Montserrat",sans-serif;font-size:7px;font-weight:700;letter-spacing:1.5px;color:#D95F00;background:rgba(217,95,0,.1);border:1px solid rgba(217,95,0,.2);padding:3px 8px;border-radius:3px;text-transform:uppercase}.cr-viewer__author{padding:20px 24px 0;display:flex;align-items:center;gap:12px}.cr-viewer__author-avatar{width:44px;height:44px;border-radius:50%;background:#D95F00;display:flex;align-items:center;justify-content:center;font-family:"Montserrat",sans-serif;font-size:16px;font-weight:700;color:#fff;flex-shrink:0}.cr-viewer__author-info{flex:1}.cr-viewer__author-name{font-family:"Montserrat",sans-serif;font-size:15px;font-weight:600;color:#fff;display:flex;align-items:center;gap:6px}.cr-viewer__author-verified{color:#D95F00;display:flex;align-items:center}.cr-viewer__author-date{font-family:"Montserrat",sans-serif;font-size:11px;font-weight:300;color:rgba(255,255,255,.3);margin-top:2px}.cr-viewer__stars{padding:16px 24px 0}.cr-viewer__title{padding:12px 24px 0;font-family:"Montserrat",sans-serif;font-size:18px;font-weight:700;color:#fff;line-height:1.3}.cr-viewer__body{padding:10px 24px 0;font-family:"Montserrat",sans-serif;font-size:14px;font-weight:300;color:rgba(255,255,255,.65);line-height:1.8}.cr-viewer__product{padding:16px 24px;margin-top:auto}.cr-viewer__product-tag{display:inline-block;font-family:"Montserrat",sans-serif;font-size:9px;font-weight:600;letter-spacing:1.5px;color:#D95F00;background:rgba(217,95,0,.08);border:1px solid rgba(217,95,0,.15);padding:5px 12px;border-radius:4px;text-transform:uppercase}.cr-viewer__footer{padding:14px 24px;border-top:1px solid rgba(255,255,255,.06);display:flex;align-items:center;justify-content:space-between}.cr-viewer__footer-text{font-family:"Montserrat",sans-serif;font-size:9px;font-weight:400;color:rgba(255,255,255,.15);letter-spacing:1px}.cr-viewer__footer-url{font-family:"Montserrat",sans-serif;font-size:9px;font-weight:600;color:rgba(255,255,255,.2);letter-spacing:1px}@media(max-width:768px){.cr-viewer__card{flex-direction:column;max-height:92vh;width:96vw;border-radius:12px}.cr-viewer__media-side{flex:none;height:45vh;min-height:260px}.cr-viewer__review-side{flex:1;overflow-y:auto}.cr-viewer__brand{padding:16px 18px 0}.cr-viewer__author{padding:14px 18px 0}.cr-viewer__author-avatar{width:38px;height:38px;font-size:14px}.cr-viewer__author-name{font-size:14px}.cr-viewer__stars{padding:12px 18px 0}.cr-viewer__title{padding:10px 18px 0;font-size:16px}.cr-viewer__body{padding:8px 18px 0;font-size:13px}.cr-viewer__product{padding:14px 18px}.cr-viewer__footer{padding:12px 18px}.cr-viewer__topbar{padding:12px 16px}}';
    document.head.appendChild(viewerStyle);

    el.innerHTML =
      '<div class="cr-viewer__topbar">' +
        '<span class="cr-viewer__counter" id="crv-counter"></span>' +
        '<button class="cr-viewer__close" id="crv-close"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg></button>' +
      '</div>' +
      '<div class="cr-viewer__card" id="crv-card">' +
        '<div class="cr-viewer__media-side" id="crv-stage">' +
          '<button class="cr-viewer__nav cr-viewer__prev" id="crv-prev"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg></button>' +
          '<button class="cr-viewer__nav cr-viewer__next" id="crv-next"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg></button>' +
          '<div class="cr-viewer__dots" id="crv-dots"></div>' +
        '</div>' +
        '<div class="cr-viewer__review-side" id="crv-info"></div>' +
      '</div>';
    document.body.appendChild(el);

    var stage = gel('crv-stage'), counter = gel('crv-counter'), dots = gel('crv-dots'), info = gel('crv-info');
    var closeBtn = gel('crv-close'), prevBtn = gel('crv-prev'), nextBtn = gel('crv-next');
    var media = [], idx = 0, review = null, mediaEl = null;

    function open(reviewId, startIdx) {
      review = reviewsStore[reviewId];
      if (!review) return;
      media = (review.media && review.media.length) ? review.media : [];
      idx = media.length ? Math.min(startIdx || 0, media.length - 1) : 0;
      el.hidden = false;
      document.body.style.overflow = 'hidden';
      render();
      renderInfo();
    }

    function close() {
      el.hidden = true;
      document.body.style.overflow = '';
      var vid = stage.querySelector('video');
      if (vid) { vid.pause(); vid.src = ''; }
    }

    function render() {
      var oldVid = stage.querySelector('video');
      if (oldVid) { oldVid.pause(); oldVid.src = ''; }
      var oldMedia = stage.querySelector('.cr-viewer__media');
      if (oldMedia) oldMedia.remove();
      var oldEmpty = stage.querySelector('.cr-viewer__no-media');
      if (oldEmpty) oldEmpty.remove();

      if (!media.length) {
        var emptyEl = document.createElement('div');
        emptyEl.className = 'cr-viewer__no-media';
        emptyEl.innerHTML = '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.15)" stroke-width="1"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>';
        stage.insertBefore(emptyEl, prevBtn);
        counter.textContent = '';
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        dots.innerHTML = '';
        return;
      }

      var m = media[idx];
      if (m.type === 'video') {
        mediaEl = document.createElement('video');
        mediaEl.className = 'cr-viewer__media';
        mediaEl.src = m.url;
        mediaEl.controls = true;
        mediaEl.autoplay = true;
        mediaEl.playsInline = true;
        mediaEl.setAttribute('controlsList', 'nodownload noplaybackrate');
        mediaEl.disablePictureInPicture = true;
        mediaEl.oncontextmenu = function(e) { e.preventDefault(); return false; };
      } else {
        mediaEl = document.createElement('img');
        mediaEl.className = 'cr-viewer__media';
        mediaEl.src = m.url.replace('/upload/', '/upload/c_limit,w_1600,q_auto/');
        mediaEl.alt = 'Review photo';
      }
      stage.insertBefore(mediaEl, prevBtn);

      counter.textContent = (idx + 1) + ' / ' + media.length;
      var multi = media.length > 1;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;

      dots.innerHTML = '';
      if (multi) {
        media.forEach(function(_, i) {
          var dot = document.createElement('button');
          dot.className = 'cr-viewer__dot' + (i === idx ? ' active' : '');
          dot.addEventListener('click', function() { idx = i; render(); });
          dots.appendChild(dot);
        });
      }
    }

    function renderInfo() {
      if (!review) return;
      info.innerHTML =
        '<div class="cr-viewer__brand">' +
          '<span class="cr-viewer__brand-logo">CYPHER</span>' +
          '<span class="cr-viewer__brand-badge">Verified Owner</span>' +
        '</div>' +
        '<div class="cr-viewer__author">' +
          '<div class="cr-viewer__author-avatar">' + esc(review.name.charAt(0).toUpperCase()) + '</div>' +
          '<div class="cr-viewer__author-info">' +
            '<div class="cr-viewer__author-name">' + esc(review.name) +
              '<span class="cr-viewer__author-verified"><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg></span>' +
            '</div>' +
            '<div class="cr-viewer__author-date">' + (review.date ? fmtDate(review.date) : '') + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="cr-viewer__stars">' + starsHtml(review.rating, 'md') + '</div>' +
        (review.title ? '<div class="cr-viewer__title">' + esc(review.title) + '</div>' : '') +
        '<div class="cr-viewer__body">' + esc(review.body) + '</div>' +
        (review.product_title ? '<div class="cr-viewer__product"><span class="cr-viewer__product-tag">' + esc(review.product_title) + '</span></div>' : '') +
        '<div class="cr-viewer__footer">' +
          '<span class="cr-viewer__footer-text">Customer Review</span>' +
          '<span class="cr-viewer__footer-url">cypherwatches.com</span>' +
        '</div>';
    }

    function next() { if (media.length > 1) { idx = (idx + 1) % media.length; render(); } }
    function prev() { if (media.length > 1) { idx = (idx - 1 + media.length) % media.length; render(); } }

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', prev);
    nextBtn.addEventListener('click', next);

    el.addEventListener('click', function(e) { if (e.target === el) close(); });

    document.addEventListener('keydown', function(e) {
      if (el.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    });

    var touchStartX = 0, touchStartY = 0;
    stage.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) { if (dx < 0) next(); else prev(); }
    }, { passive: true });

    viewer = { open: open, close: close };
    return viewer;
  }

  function initGalleryClicks() {
    document.addEventListener('click', function(e) {
      if (e.target.closest('.cr-helpful, .cr-btn, a, button:not(.cr-gallery__more)')) return;
      var galleryItem = e.target.closest('[data-review-id][data-media-idx]');
      if (galleryItem) {
        getViewer().open(galleryItem.dataset.reviewId, parseInt(galleryItem.dataset.mediaIdx) || 0);
        return;
      }
      var card = e.target.closest('.cr-card[data-review-id]');
      if (card) { getViewer().open(card.dataset.reviewId, 0); }
    });
  }

  // ============================================================
  // CLOUDINARY UPLOAD
  // ============================================================
  function createUploader(dzId, fiId, pvId) {
    var dz = gel(dzId), fi = gel(fiId), pv = gel(pvId);
    if (!dz || !fi) return null;
    var uploaded = [];

    fi.removeAttribute('hidden');
    fi.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;overflow:hidden;clip:rect(0,0,0,0);pointer-events:none;';
    document.body.appendChild(fi);

    dz.addEventListener('click', function(e) { e.stopPropagation(); fi.value=''; fi.click(); });
    dz.addEventListener('touchend', function(e) { e.preventDefault(); e.stopPropagation(); fi.value=''; fi.click(); });
    dz.addEventListener('dragover', function(e) { e.preventDefault(); e.stopPropagation(); dz.classList.add('drag-over'); });
    dz.addEventListener('dragleave', function() { dz.classList.remove('drag-over'); });
    dz.addEventListener('drop', function(e) { e.preventDefault(); e.stopPropagation(); dz.classList.remove('drag-over'); handleFiles(e.dataTransfer.files); });
    document.addEventListener('dragover', function(e){e.preventDefault()});
    document.addEventListener('drop', function(e){e.preventDefault()});
    fi.addEventListener('change', function() { if(fi.files.length>0) handleFiles(fi.files); });

    function handleFiles(files) {
      var rem = MAX_FILES - uploaded.length;
      if (rem <= 0) { alert('Maximum '+MAX_FILES+' files.'); return; }
      Array.from(files).slice(0,rem).forEach(function(f) {
        var iv = f.type.startsWith('video/'), mx = iv?MAX_VID:MAX_IMG;
        if (f.size > mx) { alert((iv?'Video':'Image')+' too large.'); return; }
        uploadFile(f);
      });
    }

    function uploadFile(f) {
      var iv = f.type.startsWith('video/');
      var th = document.createElement('div'); th.className='cr-upload__thumb';
      var url = URL.createObjectURL(f);
      th.innerHTML = (iv?'<video src="'+url+'" muted></video><span class="cr-upload__thumb-video-badge">Video</span>':'<img src="'+url+'">')+'<div class="cr-upload__thumb-uploading"><div class="cr-spinner"></div></div>';
      if(pv)pv.appendChild(th);

      var fd = new FormData(); fd.append('file',f); fd.append('upload_preset',UPLOAD_PRESET); fd.append('folder','cypher-reviews');
      var xhr = new XMLHttpRequest();
      xhr.open('POST','https://api.cloudinary.com/v1_1/'+CLOUD_NAME+'/'+(iv?'video':'image')+'/upload');
      xhr.upload.addEventListener('progress',function(e){if(e.lengthComputable){var o=th.querySelector('.cr-upload__thumb-uploading');if(o)o.innerHTML='<div style="color:#D95F00;font-size:11px;font-weight:600;">'+Math.round(e.loaded/e.total*100)+'%</div>'}});
      xhr.addEventListener('load',function(){
        if(xhr.status>=200&&xhr.status<300){
          var r=JSON.parse(xhr.responseText);
          var mi={type:iv?'video':'image',url:r.secure_url,public_id:r.public_id};
          if(iv)mi.thumb=r.secure_url.replace(/\.[^.]+$/,'.jpg');
          uploaded.push(mi);
          var o=th.querySelector('.cr-upload__thumb-uploading');if(o)o.remove();
          var rb=document.createElement('button');rb.className='cr-upload__thumb-remove';rb.textContent='\u00d7';rb.type='button';
          rb.addEventListener('click',function(){var x=uploaded.indexOf(mi);if(x>-1)uploaded.splice(x,1);th.remove()});
          th.appendChild(rb);
        }else{th.remove();alert('Upload failed.')}
      });
      xhr.addEventListener('error',function(){th.remove();alert('Upload failed.')});
      xhr.send(fd);
    }

    return{getMedia:function(){return uploaded.map(function(m){return{type:m.type,url:m.url,thumb:m.thumb}})},clear:function(){uploaded=[];if(pv)pv.innerHTML=''}};
  }

  // ============================================================
  // HELPERS
  // ============================================================
  function showSuccess(modal){
    var ov=document.createElement('div');ov.className='cr-success-overlay';
    ov.innerHTML='<div class="cr-success-box"><svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#D95F00" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-5"/></svg><h3 class="cr-success-title">Thank You!</h3><p class="cr-success-text">Your review has been submitted and will appear after approval.</p><button class="cr-btn cr-btn--primary cr-success-close" type="button">Done</button></div>';
    var mc=modal.querySelector('.cr-modal__content')||modal;mc.appendChild(ov);
    ov.querySelector('.cr-success-close').addEventListener('click',function(){ov.remove();closeModal(modal)});
    setTimeout(function(){if(ov.parentNode){ov.remove();closeModal(modal)}},4500);
  }

  function showStatus(el,msg,ok){if(!el)return;el.hidden=false;el.className='cr-status cr-status--'+(ok?'ok':'err');el.textContent=msg;el.scrollIntoView({behavior:'smooth',block:'nearest'})}

  function api(action,params,post){
    var u=API_URL+'?action='+action;
    if(params)Object.keys(params).forEach(function(k){u+='&'+k+'='+encodeURIComponent(params[k])});
    if(post)return fetch(API_URL,{method:'POST',body:JSON.stringify(post),redirect:'follow'}).then(function(r){return r.json()});
    return fetch(u,{redirect:'follow'}).then(function(r){return r.json()});
  }

  function initStars(c,h,l){
    if(!c)return;var bs=$$('.cr-star-btn',c),v=0;
    function s(n,ho){bs.forEach(function(b,i){b.classList.toggle('active',i<n);b.classList.toggle('hover',ho&&i<n)});if(l)l.textContent=LABELS[n]||''}
    bs.forEach(function(b){
      b.addEventListener('mouseenter',function(){s(+b.dataset.v,true)});
      b.addEventListener('mouseleave',function(){s(v,false)});
      b.addEventListener('click',function(){v=+b.dataset.v;if(h)h.value=v;s(v,false)});
    });
  }

  /* MODIFIED: Safely increased the review modal's z-index to max absolute value to pop over everything */
  function openModal(m){
    if(!m)return;
    m.hidden=false;
    m.style.setProperty('z-index', '2147483647', 'important');
    document.body.style.overflow='hidden';
  }
  
  function closeModal(m){if(!m)return;m.hidden=true;document.body.style.overflow=''}

  function wireModal(modal,btns){
    if(!modal)return;
    btns.forEach(function(b){if(b)b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();openModal(modal)})});
    var bd=$('.cr-modal__backdrop',modal),cl=$('.cr-modal__close',modal);
    if(bd)bd.addEventListener('click',function(){closeModal(modal)});
    if(cl)cl.addEventListener('click',function(){closeModal(modal)});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)closeModal(modal)});
  }

  function initChars(t,c){if(t&&c)t.addEventListener('input',function(){c.textContent=t.value.length})}

  // ============================================================
  // PRODUCT PAGE
  // ============================================================
    function initProductPage(){
    var sec=gel('cypher-reviews');if(!sec)return;
    var handle=sec.dataset.productHandle;if(!handle)return;
    var groupHandles = getGroupHandles(handle);

    loadBadge(groupHandles);
    initGalleryClicks();
    wireModal($('#cr-modal'),[gel('cr-write-btn')]);
    initStars(gel('cr-star-input'),gel('cr-rating'),gel('cr-star-label'));
    initChars(gel('cr-body'),gel('cr-chars'));
    var up=createUploader('cr-dropzone','cr-file-input','cr-previews');

    var sb=gel('cr-submit');
    if(sb)sb.addEventListener('click',function(){
      var r=+(gel('cr-rating')||{}).value;
      var n=((gel('cr-name')||{}).value||'').trim();
      var e=((gel('cr-email')||{}).value||'').trim();
      var t=((gel('cr-title')||{}).value||'').trim();
      var b=((gel('cr-body')||{}).value||'').trim();
      var st=gel('cr-status');
      var m=up?up.getMedia():[];
      if(!r)return showStatus(st,'Please select a star rating.',false);
      if(!n)return showStatus(st,'Please enter your name.',false);
      if(!e||e.indexOf('@')===-1)return showStatus(st,'Please enter a valid email.',false);
      if(!b||b.length<20)return showStatus(st,'Please write at least 20 characters.',false);
      sb.disabled=true;sb.textContent='Submitting...';
      api(null,null,{product_handle:handle,product_title:sec.dataset.productTitle,rating:r,name:n,email:e,review_title:t,body:b,media:m})
      .then(function(res){
        if(res.error){showStatus(st,res.error,false)}
        else{showSuccess(gel('cr-modal'));gel('cr-rating').value='0';gel('cr-name').value='';gel('cr-email').value='';gel('cr-title').value='';gel('cr-body').value='';$$('.cr-star-btn',gel('cr-star-input')).forEach(function(b){b.classList.remove('active')});if(up)up.clear();if(st)st.hidden=true}
      })
      .catch(function(){showStatus(st,'Something went wrong.',false)})
      .finally(function(){sb.disabled=false;sb.textContent='Submit Review'});
    });

    var ld=gel('cr-loading'),em=gel('cr-empty'),sm=gel('cr-summary'),ls=gel('cr-reviews-list');
    var productReviews = [];
    var productPage = 1;
    var allGroupReviews = [];

    // The Apps Script already pools all colourways of a model under one
    // canonical handle, so a SINGLE call with this product's own handle
    // returns the whole group exactly once. (The old per-handle loop asked
    // N times and concatenated, duplicating every review N times.)
    api('reviews', { product: handle }).then(function(d) {
      if (d.reviews && d.reviews.length) {
        allGroupReviews = d.reviews.slice();
      }
    }).catch(function(){}).then(function() {
      if(ld)ld.style.display='none';
      if(!allGroupReviews.length){if(em)em.style.display='block';return}

      allGroupReviews.sort(function(a,b){
        if(a.pinned&&!b.pinned)return -1;
        if(!a.pinned&&b.pinned)return 1;
        return new Date(b.date)-new Date(a.date);
      });

      productReviews = allGroupReviews;
      storeReviews(allGroupReviews);

      var totalRating=0, dist=[0,0,0,0,0];
      allGroupReviews.forEach(function(r){totalRating+=r.rating;if(r.rating>=1&&r.rating<=5)dist[r.rating-1]++});
      var combinedSummary={
        avg: Math.round((totalRating/allGroupReviews.length)*10)/10,
        count: allGroupReviews.length,
        dist: dist
      };

      if(combinedSummary.count>0&&sm){
        sm.style.display='grid';
        var s=combinedSummary;
        sm.innerHTML='<div class="cr-summary__score"><span class="cr-summary__num">'+s.avg.toFixed(1)+'</span><div>'+starsHtml(s.avg,'md')+'<div class="cr-summary__sub">Based on '+s.count+' review'+(s.count!==1?'s':'')+'</div></div></div><div class="cr-bars">'+[5,4,3,2,1].map(function(n){var c=s.dist[n-1],p=s.count>0?Math.round(c/s.count*100):0;return'<div class="cr-bar"><span class="cr-bar__label">'+n+'★</span><div class="cr-bar__track"><div class="cr-bar__fill" style="width:'+p+'%"></div></div><span class="cr-bar__count">'+c+'</span></div>'}).join('')+'</div>';
      }

      renderProductPage();

      if (productReviews.length > PER_PAGE) {
        var loadMoreWrap = document.createElement('div');
        loadMoreWrap.className = 'cr-loadmore';
        loadMoreWrap.id = 'cr-product-loadmore';
        loadMoreWrap.innerHTML = '<button class="cr-btn cr-btn--outline" id="cr-product-more-btn">Load More Reviews</button>';
        ls.parentNode.insertBefore(loadMoreWrap, ls.nextSibling);
        gel('cr-product-more-btn').addEventListener('click', function() {
          productPage++;
          renderProductPage();
        });
      }
    });

    function renderProductPage() {
      var end = productPage * PER_PAGE;
      var visible = productReviews.slice(0, end);
      ls.innerHTML = visible.map(function(r) { return cardHtml(r, false); }).join('');
      var loadMoreEl = gel('cr-product-loadmore');
      if (loadMoreEl) loadMoreEl.style.display = end < productReviews.length ? 'block' : 'none';
    }
  }

   function loadBadge(handles){
    var w=gel('cr-badge');if(!w)return;
    var totalCount=0, totalSum=0;
    // Server pools by canonical handle, so ONE summary call (any handle in
    // the group) already covers the whole model. Looping all handles would
    // count the same pool once per colourway and inflate the badge.
    api('summary',{product:handles[0]}).then(function(d){
      if(d.summary&&d.summary.count>0){
        totalCount=d.summary.count;
        totalSum=d.summary.avg*d.summary.count;
      }
    }).catch(function(){}).then(function(){
      if(totalCount>0){
        var avg=Math.round((totalSum/totalCount)*10)/10;
        gel('cr-badge-stars').innerHTML=starsHtml(avg,'sm');
        gel('cr-badge-rating').textContent=avg.toFixed(1);
        gel('cr-badge-count').textContent=totalCount+' Review'+(totalCount!==1?'s':'');
        w.style.display='block';
      }
    });
  }

  // ============================================================
  // ALL REVIEWS PAGE
  // ============================================================
  var allReviews=[],pageNum=1;

  function initAllReviewsPage(){
    var pg=gel('cr-page');if(!pg)return;
    initGalleryClicks();
    wireModal(gel('cr-page-modal'),[gel('cr-page-write-btn'),gel('cr-page-empty-write')]);
    initStars(gel('cr-p-star-input'),gel('cr-p-rating'),gel('cr-p-star-label'));
    initChars(gel('cr-p-body'),gel('cr-p-chars'));
    var up=createUploader('cr-p-dropzone','cr-p-file-input','cr-p-previews');

    var sb=gel('cr-p-submit');
    if(sb)sb.addEventListener('click',function(){
      var ps=gel('cr-p-product');
      var h=ps?ps.value:'';
      var pt=ps&&ps.selectedOptions[0]?ps.selectedOptions[0].textContent:'';
      var r=+(gel('cr-p-rating')||{}).value;
      var n=((gel('cr-p-name')||{}).value||'').trim();
      var e=((gel('cr-p-email')||{}).value||'').trim();
      var t=((gel('cr-p-title')||{}).value||'').trim();
      var b=((gel('cr-p-body')||{}).value||'').trim();
      var st=gel('cr-p-status');
      var m=up?up.getMedia():[];
      if(!h)return showStatus(st,'Please select a model.',false);
      if(!r)return showStatus(st,'Please select a star rating.',false);
      if(!n)return showStatus(st,'Please enter your name.',false);
      if(!e||e.indexOf('@')===-1)return showStatus(st,'Please enter a valid email.',false);
      if(!b||b.length<20)return showStatus(st,'Please write at least 20 characters.',false);
      sb.disabled=true;sb.textContent='Submitting...';
      api(null,null,{product_handle:h,product_title:pt,rating:r,name:n,email:e,review_title:t,body:b,media:m})
      .then(function(res){
        if(res.error){showStatus(st,res.error,false)}
        else{showSuccess(gel('cr-page-modal'));if(ps)ps.value='';gel('cr-p-rating').value='0';gel('cr-p-name').value='';gel('cr-p-email').value='';gel('cr-p-title').value='';gel('cr-p-body').value='';$$('.cr-star-btn',gel('cr-p-star-input')).forEach(function(b){b.classList.remove('active')});if(up)up.clear();if(st)st.hidden=true}
      })
      .catch(function(){showStatus(st,'Something went wrong.',false)})
      .finally(function(){sb.disabled=false;sb.textContent='Submit Review'});
    });

    ['cr-stat-total','cr-stat-avg','cr-stat-models'].forEach(function(id){
      var el=gel(id);if(el)el.innerHTML='<span class="cr-shimmer">&nbsp;&nbsp;&nbsp;&nbsp;</span>';
    });

    var ld=gel('cr-page-loading'),ls=gel('cr-page-list'),em=gel('cr-page-empty'),lm=gel('cr-page-loadmore');

    var sel=gel('cr-p-product'),fsel=gel('cr-f-model');
    COLLECTIONS.forEach(function(c){
      if(sel){var o=document.createElement('option');o.value=c.handles[0];o.textContent=c.name;sel.appendChild(o)}
      if(fsel){var o2=document.createElement('option');o2.value=c.name;o2.textContent=c.name;fsel.appendChild(o2)}
    });
    var urlProduct=new URLSearchParams(window.location.search).get('product');
    if(urlProduct&&sel){
      for(var ci=0;ci<COLLECTIONS.length;ci++){
        if(COLLECTIONS[ci].handles.indexOf(urlProduct)!==-1){sel.value=COLLECTIONS[ci].handles[0];break}
      }
      openModal(gel('cr-page-modal'));
    }

    api('all').then(function(d){
      allReviews=d.reviews||[];
      storeReviews(allReviews);
      var s=d.stats||{};
      if(ld)ld.style.display='none';
      var te=gel('cr-stat-total');if(te)te.textContent=s.total_reviews||0;
      var ae=gel('cr-stat-avg');if(ae)ae.textContent=(s.avg_rating||0).toFixed(1);
      var me=gel('cr-stat-models');if(me)me.textContent=s.total_models||0;
      if(!allReviews.length){if(em)em.style.display='block';return}
      renderPage();
    }).catch(function(){
      if(ld)ld.innerHTML='<p style="color:var(--cr-muted)">Unable to load reviews.</p>';
      ['cr-stat-total','cr-stat-avg','cr-stat-models'].forEach(function(id){var el=gel(id);if(el)el.textContent='\u2014'});
    });

    ['cr-f-model','cr-f-rating','cr-f-sort'].forEach(function(id){
      var el=gel(id);if(el)el.addEventListener('change',function(){pageNum=1;renderPage()});
    });
    var mb=gel('cr-page-more-btn');
    if(mb)mb.addEventListener('click',function(){pageNum++;renderPage()});
  }

  function renderPage(){
    var ls=gel('cr-page-list'),lm=gel('cr-page-loadmore'),em=gel('cr-page-empty');
    if(!ls)return;
    var mo=(gel('cr-f-model')||{}).value||'all';
    var ra=(gel('cr-f-rating')||{}).value||'all';
    var so=(gel('cr-f-sort')||{}).value||'newest';

    var f=allReviews.filter(function(r){
      if(mo!=='all'){
        var matchGroup=false;
        for(var ci=0;ci<COLLECTIONS.length;ci++){
          if(COLLECTIONS[ci].name===mo&&COLLECTIONS[ci].handles.indexOf(r.product_handle)!==-1){matchGroup=true;break}
        }
        if(!matchGroup)return false;
      }
      if(ra!=='all'&&r.rating<+ra)return false;
      return true;
    });

    f.sort(function(a,b){
      if(a.pinned&&!b.pinned)return -1;
      if(!a.pinned&&b.pinned)return 1;
      switch(so){
        case'oldest':return new Date(a.date)-new Date(b.date);
        case'highest':return b.rating-a.rating;
        case'helpful':return(b.helpful||0)-(a.helpful||0);
        default:return new Date(b.date)-new Date(a.date);
      }
    });

    var end=pageNum*PER_PAGE,vis=f.slice(0,end);
    if(!vis.length){ls.innerHTML='';if(em)em.style.display='block';if(lm)lm.style.display='none';return}
    if(em)em.style.display='none';
    ls.innerHTML=vis.map(function(r){return cardHtml(r,true)}).join('');
    if(lm)lm.style.display=end<f.length?'block':'none';
  }

  function initBadgeScroll(){
    var b=gel('cr-badge-link');
    if(b)b.addEventListener('click',function(e){e.preventDefault();var t=gel('cypher-reviews');if(t)t.scrollIntoView({behavior:'smooth',block:'start'})});
  }

  function init(){initBadgeScroll();initProductPage();initAllReviewsPage()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();